import { useCallback, useEffect, useMemo, useRef } from 'react';

import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { normalizeEditorInputHtml, uploadImageFile } from '../helpers/html-images';

export default function TextEditor(porps) {

    const quillRef = useRef(null);

    const {
        value = "",
        onChange = () => {}
    } = porps

    const onChangeRef = useRef(onChange);

    useEffect(() => {
        onChangeRef.current = onChange;
    }, [onChange]);

    const initialValueRef = useRef();
    if (initialValueRef.current === undefined) {
        initialValueRef.current = normalizeEditorInputHtml(value);
    }

    const handleImageUpload = useCallback(() => {
        const input = document.createElement('input');
        input.setAttribute('type', 'file');
        input.setAttribute('accept', 'image/*');
        input.click();

        input.onchange = async () => {
            const file = input.files?.[0];
            if (!file) return;

            try {
                const url = await uploadImageFile(file);
                const editor = quillRef.current?.getEditor();
                const range = editor?.getSelection(true);
                if (!editor) return;

                const index = range?.index || editor.getLength();
                editor.insertEmbed(index, 'image', url, 'user');
                editor.setSelection(index + 1);
                onChangeRef.current(editor.root.innerHTML);
            } catch (error) {
                console.log(error);
            }
        };
    }, []);

    const handleLink = useCallback(() => {
        const editor = quillRef.current?.getEditor();
        const range = editor?.getSelection(true);
        if (!editor || !range || range.length === 0) {
            window.alert('ابتدا متن مورد نظر برای لینک را انتخاب کنید.');
            return;
        }

        const currentLink = editor.getFormat(range).link || '';
        const enteredUrl = window.prompt(
            'آدرس لینک را وارد کنید. برای حذف لینک، این کادر را خالی بگذارید:',
            currentLink,
        );

        if (enteredUrl === null) return;

        const trimmedUrl = enteredUrl.trim();
        const href = /^(?:[a-z0-9-]+\.)+[a-z]{2,}(?:[/:?#]|$)/i.test(trimmedUrl)
            ? `https://${trimmedUrl}`
            : trimmedUrl;

        editor.formatText(range.index, range.length, 'link', href || false, 'user');
        onChangeRef.current(editor.root.innerHTML);
    }, []);

    const modules = useMemo(() => ({
        toolbar: {
            container: [
                [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
                ['bold', 'italic', 'underline', 'strike', 'blockquote'],
                [{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'indent': '-1' }, { 'indent': '+1' }],
                ['link', 'image'],
                ['clean'],
            ],
            handlers: {
                image: handleImageUpload,
                link: handleLink,
            },
        },
    }), [handleImageUpload, handleLink]);

    const formats = [
        'header',
        'bold', 'italic', 'underline', 'strike', 'blockquote',
        'list', 'bullet', 'indent',
        'link', 'image'
    ];

    const handleChange = useCallback((html) => {
        onChangeRef.current(html);
    }, []);

    return (
        <div className='text-editor-modal textEditorInModal rtl-editor'>
            <ReactQuill 
                ref={quillRef}
                theme="snow" 
                defaultValue={initialValueRef.current}
                onChange={handleChange} 
                modules={modules}
                formats={formats}
            />
        </div>
    )
}
